import styled from 'styled-components'

export const IconButton = styled.button.attrs({
  className: 'sdds-btn sdds-btn-primary sdds-btn-md'
})`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: var(--tds-grey-500);
    margin-right: var(--tds-spacing-element-16);
    margin-top: var(--tds-spacing-element-12);
    margin-bottom: var(--tds-spacing-element-12);
    align-self: flex-start;
    color: var(--tds-grey-50);
  }
  padding-left: 4px;
  svg {
    width: 16px;
    height: 16px;
  }
`
